import { makeApi } from 'JIX/utils.js';

const API_VERSION = 1;
const api = makeApi(`/api/user/v${API_VERSION}/`, { json: true });

export function updateUser(user) {
    return api('PATCH', [], { user });
}

export function getFollowConsent() {
    return api('GET', ['follow-consent']);
}

export function setFollowConsent(remember) {
    return api('POST', ['follow-consent'], { remember });
}

export function getContactConsent() {
    return api('GET', ['contact-consent']);
}

export function setContactConsent(remember) {
    return api('POST', ['contact-consent'], { remember });
}
